import { Injectable } from '@angular/core';
import info from 'src/version.json';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInformationService {
  public version = info.version;
}
